/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { qualificationsType } from "ps-shared";
import { FormikMultiCreateSelect } from "src/components/Forms/FormikMultiCreateSelect";
import FormikMultiSelect, { SelectOption } from "src/components/Forms/FormikMultiSelect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import trainingOrgs from "ps-shared/models/forms/trainingOrgs.json";
import { FormGroup, Label, UncontrolledTooltip } from "reactstrap";

interface QualificationsProps {
  values: qualificationsType;
}

// tslint:disable-next-line:no-empty-interface
interface QualificationsState {
  trainingOrgs: SelectOption[];
}
// eslint-disable-next-line import/no-default-export
export default class Qualifications extends React.Component<QualificationsProps, QualificationsState> {
  constructor(props: QualificationsProps) {
    super(props);
    this.state = {
      trainingOrgs: trainingOrgs.map((pn: string) => {
        return {
          label: pn,
          value: pn,
        } as SelectOption;
      }),
    };
  }

  // tslint:disable:max-line-length
  public render() {
    return (
      <>
        <FormGroup className="mb-3 date" id="datetimepicker">
          <UncontrolledTooltip delay={0} placement="right" target="licensesTT">
            Follow format type, #number state; for example - 'Doctor of Medicine, #123456 Maryland'
          </UncontrolledTooltip>
          <Label for="practiceYears">
            What licenses do you hold? <i>Note format</i>
          </Label>
          &nbsp;
          <span id="licensesTT" style={{ fontSize: "10px" }}>
            <FontAwesomeIcon icon={faInfoCircle} />
          </span>
          <br />
          <FormikMultiCreateSelect
            options={[]}
            value={this.props.values.licenses}
            name="licenses"
            noOptionsMessage="Add your licenses 'type, #number state' eg 'Doctor of Medicine, #123456 Maryland'"
          />
        </FormGroup>
        <FormGroup className="mb-3">
          <UncontrolledTooltip delay={0} placement="right" target="educationTT">
            At a minimum, add the institution of highest degree earned. Recommended format: school, degree, year
            completed.
          </UncontrolledTooltip>
          <Label for="education">Education:</Label>&nbsp;
          <span id="educationTT" style={{ fontSize: "10px" }}>
            <FontAwesomeIcon icon={faInfoCircle} />
          </span>
          <br />
          <FormikMultiCreateSelect
            options={[]}
            value={this.props.values.education}
            name="education"
            noOptionsMessage="Add your education eg 'University of Texas'"
          />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="training">Have you been trained by any of the following?</Label>
          <br />
          <FormikMultiSelect
            options={this.state.trainingOrgs}
            value={this.props.values.trainingOrg}
            name="trainingOrg"
          />
        </FormGroup>
        <FormGroup className="mb-3">
          <UncontrolledTooltip delay={0} placement="right" target="trainingTT">
            Add professional trainings. For example, MAPS MDMA Therapy Program; Internal Family Systems.
          </UncontrolledTooltip>
          <Label for="training">Training:</Label>&nbsp;
          <span id="trainingTT" style={{ fontSize: "10px" }}>
            <FontAwesomeIcon icon={faInfoCircle} />
          </span>
          <br />
          <FormikMultiCreateSelect
            options={[]}
            value={this.props.values.training}
            name="training"
            noOptionsMessage="Select a psychedelic training or add your own"
          />
        </FormGroup>
      </>
    );
  }
}
